<template>
  <div>
    <b-modal id="bv-modal-tracking-code" hide-footer>
      <template #modal-title>Tracking code for {{site.name}}</template>

      <span v-if="site.code !== 'Installed'">
        <div>How do you want to install tracking code?</div>
        <div class="row py-3">
          <div class="col-md-4 pb-3 pb-md-0"><a href="#/" @click="setSelected('wordpress')" :class="`switch_button ${active_wordpress}`">WordPress</a></div>
          <div class="col-md-4 pb-3 pb-md-0"><a href="#/" @click="setSelected('shopify')" :class="`switch_button ${active_shopify}`">Shopify</a></div>
          <div class="col-md-4"><a href="#/" @click="setSelected('website')" :class="`switch_button ${active_website}`">Website</a></div>
        </div>
      </span>
      <div>

      <div v-if="site.code == 'Installed'" class="text-center pb-3">
        <span v-if="site.code=='Installed'"><i class="fas fa-check-circle credit mr-2" :title="site.code"></i></span>Tracking code installed
      </div>

      <div v-if="site.code == 'Not installed'">

        <div class="pb-3" v-if="selected == 'website'">
          <ul>
          <li>Paste the following script into your website footer so it appears on every page</li>
          </ul>
          <pre class="code-block mb-0"><code ref="codeBlock">&lt;script src="https://supalytic.com/supalytic.js" data-site-id="{{site.id}}" defer&gt;&lt;/script&gt;</code></pre>
          <button v-if="!copied" class="code" @click="copyCode"><i class="fas fa-clone icon mr-2"></i>Copy</button>
          <button v-else class="code copied"><i class="fas fa-check icon mr-2"></i>Copied</button>
        </div>

        <div class="pb-3" v-else-if="selected == 'shopify'">
          <div>
            <ul>
              <li>From your Shopify admin go to <b>Online Store → Themes</b></li>
              <li>Find your active theme click <b>Actions → Edit code</b></li>
              <li>In the <b>Layout</b> folder open <b>theme.liquid</b></li>
              <li>Scroll to the bottom of the file just before the closing <b>&lt;/body&gt;</b> tag</li>
              <li>Paste the following script and click <b>Save</b></li>
            </ul>
          </div>
          <pre class="code-block mb-0"><code ref="codeBlock">&lt;script src="https://supalytic.com/supalytic.js" data-site-id="{{site.id}}" defer&gt;&lt;/script&gt;</code></pre>
          <button v-if="!copied" class="code" @click="copyCode"><i class="fas fa-clone icon mr-2"></i>Copy</button>
          <button v-else class="code copied"><i class="fas fa-check icon mr-2"></i>Copied</button>
        </div>

        <div v-else-if="selected == 'wordpress'">
          <div>
            <ul>
              <li>Download, install and activate <a class="blue2" href="/wordpress/supalytic.zip">WordPress plugin</a></li>
              <li>Go to plugin settings</li>
              <li>Enter site id <b style="color:red;">{{site.id}}</b> and click save</li>
            </ul>
          </div>
        </div>

      </div>

      </div>

      <div class="row pb-2">
        <div class="col mt-2 mt-md-0">
            <button v-if="updating" type="button" class="btn btn-success submit col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-success submit col" @click="saveProfile">Check tracking code</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
props: ['site'],
  data() {
    return {
      updating: false,
      copied: false,
      selected: null,
      active_wordpress: null,
      active_website: null,
      active_shopify: null,
    };
  },

  methods: {

    setSelected(option) {
      this.selected = option;
      this.active_wordpress = option === 'wordpress' ? 'active' : null;
      this.active_website = option === 'website' ? 'active' : null;
      this.active_shopify = option === 'shopify' ? 'active' : null;
    },

    copyCode() {
      const code = this.$refs.codeBlock.innerText;
      navigator.clipboard.writeText(code).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      });
    },


    hideModalTrackingCode() {
      this.$bvModal.hide('bv-modal-tracking-code');
    },

            saveProfile() {

             this.updating = true;

              axios.post('/api/check-tracking', {
                site_id: this.site.id,
              })
               .then((response) => {
                   this.successAlert(response.data.message);
                   this.hideModalTrackingCode();
                }).catch((error) => {
                    this.sweetfire(error.response.data.message);
                    this.site.code = 'Not installed';
                }).finally(() => {
                    EventBus.$emit('tracking-updated');
                    this.updating = false;
                });

          },

          successAlert(text) {
            Swal.fire({
              title: text,
              customClass: { title: "popup-title", icon: "custom-icon-size" },
              icon: "success",
              showConfirmButton: false,
              timer: 3000,
            });
    },
  },
};
</script>

<style scoped>
.switch_button {
  padding: 0.5rem 0.5rem;
  border: 1px solid #000;
  border-radius: 5px;
  color: #000;
  text-decoration: none;
  background-color: #fff;
  display:block;
  text-align: center;
}

.switch_button.active {
  color: #fff;
  background-color: #000;
}

.code-block {
  color: #000000 !important; 
  font-size: 14px; 
  background-color: #fff; 
  padding: 10px; 
  display: block; 
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border:1px solid #000;
}

.icon {
font-size: 10px !important;
}

button.code{
  border:none !important;
  outline: none !important;
  width:100%;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  font-size:12px;
  padding:3px;
  color:#fff;
  background:#000;
}

/* .copied{background:#278635 !important;} */
</style>